import React from 'react'
import { Order } from '../models/order';


const OrderContext = React.createContext({
    CurrentOrder: {
        addAnalysis: false,
        addLifetimeUpdates: false,
        voucher: undefined,
        voucherCode: undefined
    } as Order,

    SetCurrentOrder: (order: Order) => { },
});

export const OrderProvider = OrderContext.Provider

export default OrderContext